export type InitialStore = {
  isMobile: boolean;
  isMaster: boolean;
  isLogin: boolean;
  isInit: boolean;
  isAgreeRule: boolean;
  nickname?: string,
  uid?: string,
  phone?: string,
  playMusic?: boolean,
  mastersess?: string,
  dashi_uid?: string,
  isExpired?: string,
  workData: {
    receiveMailCnt?: number,
    appOpenTimes?: number,
    lastSendMailTime?: string,
    lastOpenAppTime?: string,
    resultText?: string,
    color?: string,
  },
  masterClientInfo: {
    version?: string,
    masterfp?: string
  }
};


export const defaultValue = {
  isMobile: false,
  isLogin: false,
  isMaster: false,
  isInit: false,
  isAgreeRule: false,
  nickname: '',
  mastersess: '',
  dashi_uid: '',
  uid: '',
  phone: '',
  playMusic: false,
  isExpired: undefined,
  workData: {},
  masterClientInfo: {
    version: ''
  }
};

export const initialState = (config: InitialStore): InitialStore => {
  return {
    ...defaultValue,
    ...config
  };
};
